import WeeekTaskGetRequest from '@/api/Weeek/dataSource/api/project-manager/weeek/web/models/weeek-task-ws-controller/request/WeeekTaskGetRequest';
import WeeekTaskGetResponse from '@/api/Weeek/dataSource/api/project-manager/weeek/web/models/weeek-task-ws-controller/response/WeeekTaskGetResponse';
import { TaskImportDataModel, TaskImportFileModel } from '@/components/task-forms/models';
import { CheckTaskExistResultModel, GetWeeekTaskModel } from '../models';
import WeeekTaskCheckExistsRequest from '@/api/Weeek/dataSource/api/project-manager/weeek/web/models/weeek-task-ws-controller/request/WeeekTaskCheckExistsRequest';
import WeeekTaskCheckExistsResponse from '@/api/Weeek/dataSource/api/project-manager/weeek/web/models/weeek-task-ws-controller/response/WeeekTaskCheckExistsResponse';

export const mapGetWeeekTaskRequest = (request: GetWeeekTaskModel) =>
  new WeeekTaskGetRequest({
    WeeekTaskId: request.WeeekTaskId,
    WeeekTaskUrl: request.WeeekTaskUrl,
    ProjectId: request.ProjectId,
    QueueTaskId: request.QueueTaskId,
  });

export const mapGetWeeekTaskResponse = (response: WeeekTaskGetResponse) => {
  const description = response.Description.replace(/<p(\s[^>]*)?>/g, '<div$1>').replace(
    /<\/p>/g,
    '</div>',
  );

  return new TaskImportDataModel({
    WeeekTaskId: response.WeeekTaskId,
    WeeekWorkspaceId: response.WeeekWorkspaceId,
    Name: response.Name,
    Description: `<div>${description}</div>`,
    StatusId: response.Status.Id,
    TypeId: response.Type.Id,
    PriorityId: response.Priority.Id,
    Tags: response.TagList.map((tag) => tag.Id),
    DifficultyId: response.Difficulty.Id,
    Files: response.Files.map(
      (file) =>
        new TaskImportFileModel({
          Name: file.Name,
          Url: file.Url,
          Size: file.Size,
        }),
    ),
  });
};

export const mapCheckExistRequest = (req: WeeekTaskCheckExistsRequest) =>
  new WeeekTaskCheckExistsRequest({
    WeeekTaskId: req.WeeekTaskId,
    ProjectId: req.ProjectId,
  });

export const mapCheckExistResponse = (response: WeeekTaskCheckExistsResponse) =>
  new CheckTaskExistResultModel({
    IsExists: response.IsExists,
    TaskId: response.TaskId,
    QueueTaskId: response.QueueTaskId,
    NamespaceId: response.NamespaceId,
    ProjectId: response.ProjectId,
  });
